
/* eslint-disable consistent-return */

export default {
    methods: {
        /**
         * Dispatches 'yuriMenuStore/disableItemsMenu'
         * @return {Promise} Returns a promise
         */
        dispatchDisableItemsMenu() {
            return this.$store.dispatch('yuriMenuStore/disableItemsMenu');
        },

        /**
         * Abrir nueva pestaña en el menú principal
         * Estrutura:
         * const navigateToThisItem = {
         *   active: true,
         *   name: issueCreated.subject,
         *   route: {
         *      name: `issues_uuid`,
         *      params: {
         *          uuid: issueCreated.uuid
         *      },
         *      force: true
         *   }
         * };
         * @param {Object} item Configuración de la ruta y sus detalles para abrir nueva pestaña
         */
        async setMenuTab(item) {
            try {
                await this.$store.dispatch('yuriMenuStore/disableItemsMenu');
                await this.$store.dispatch('yuriMenuStore/upsertItem', item);
                await this.$router.replace(item.route);
                await this.$store.dispatch('yuriMenuStore/setActiveItem', item);
            } catch (error) {
                console.error(error);
            }
        },

        /**
         * @override
         */
        closeActiveSubmenuItemTab() {
            const itemActive = this.$store.getters['yuriMenuStore/activeSubItem'];
            return this.$store.dispatch('yuriMenuStore/removeSubItem', itemActive);
        },

        /**
         * @override
         */
        async setSubMenuTab(item) {
            try {
                const index = this.$store.getters['yuriMenuStore/activeItem'];
                await this.$store.dispatch('yuriMenuStore/upsertSubItem', { item, index });
                await this.$router.replace(item.route);
                await this.$store.dispatch('yuriMenuStore/setActiveSubItem', item);
            } catch (error) {
                console.error(error);
            }
        },

        /**
        * Cerrar pestaña actual
        * si estamos en una subpestaña y no hay otras, la cerramos y volvemos al padre
        * si hay varias subpestañas, cerramos la actual y volvemos a la subpestaña anterior
        * si no estamos en una subpestaña cerramos la pestaña y volvemos al listado
        * @param {String} listingRoute Ruta de listado a la que volver si no estamos en una subpestaña
         */
        closeActiveTab(listingRoute) {
            const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
            const subItems = this.$store.getters['yuriMenuStore/activeItemChildrens'];

            if (subItems.length > 0) {
                const actualSubTabIndex = this.$store.getters['yuriMenuStore/activeSubItem'];
                this.$store.dispatch('yuriMenuStore/removeSubItem', actualSubTabIndex).then(() => {

                    if (subItems.length === 1) {
                        const parentItem = this.$store.getters['yuriMenuStore/items'][indexActiveMenu];
                        this.$router.push(parentItem.route);
                    } else {
                        const item = subItems[actualSubTabIndex - 1];
                        this.$store.dispatch('yuriMenuStore/setActiveSubItem', { indexActiveMenu, item })
                            .then(() => {
                                if (this.$route.query.id !== item.route.query.id
                                    || this.$route.name !== item.route.query.name) {
                                    this.$router.push(item.route);
                                }
                            });
                    }
                });
            } else {
                this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu);
                this.$router.push({ name: listingRoute });
            }
        }

    }
};
